module.exports = __webpack_public_path__ + "img/featuredartist (1).07b4ce98.jpg";